import { BaseApiService } from '@/shared/api/services/base.service';
import type { PassesResponse } from '@/types/passes';

/**
 * Pro / Designer Pass catalog. Copy (name, features, price, is_active) is fully
 * resolved server-side per MONETIZATION_PIVOT principle 5 — the client renders
 * it verbatim. Display-only today; the Stripe Checkout purchase flow is a later
 * pivot task (D1/D2).
 */
class PassesService extends BaseApiService {
  async getPasses(): Promise<PassesResponse> {
    return this.httpGet<PassesResponse>('/v1/passes');
  }
}

export const passesService = new PassesService();
